<template>
  <div class="c-page page-not-found">
    <div class="page-not-found__title">
      {{ $t('systemMessages.pageNotFound') }}
    </div>
    <div class="page-not-found__404">
      404
    </div>
    <router-link to="/" class="page-not-found__home-link">
      {{ $t('systemMessages.goToMainPage') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Page404',
};
</script>

<style lang="scss" scoped>
</style>
